import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { translatedLink } from '@swf/core/utils';

import {
  TXTWCL_Set_your_Xa_hrefXXN0XXdeposit__ELL,
  TXTWCL_Your_Xa_hrefXXN0XXdeposit_limi_ELL
} from './SetLimitContent.messages.json';

const SetLimitContent: React.FC<{ limitSet?: boolean }> = ({ limitSet }) => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();

  return (
    <span>
      {limitSet ? (
        <Translation
          {...TXTWCL_Your_Xa_hrefXXN0XXdeposit_limi_ELL}
          values={{ a: translatedLink({ onClick: () => enqueue({ path: depositLimitPath }) }) }}
        />
      ) : (
        <Translation
          {...TXTWCL_Set_your_Xa_hrefXXN0XXdeposit__ELL}
          values={{ a: translatedLink({ onClick: () => enqueue({ path: depositLimitPath }) }) }}
        />
      )}
    </span>
  );
};
export default SetLimitContent;
